export const MODAL_CONFIG = {
  zIndex: {
    overlay: 1000,
    closeButton: 1001
  },
  animation: {
    duration: '0.3s',
    timing: 'cubic-bezier(0.16, 1, 0.3, 1)'
  }
};
